import { isEmpty } from 'lodash';
import React, { FC } from 'react';

import {
	SliderNews,
	SliderNewsProps,
} from '@/components/molecules/SliderNews/render';
import { SectionAccordion } from '../SectionAccordion/render';

import block from './block.json';

/**
 * TYPINGS
 */
export type SectionPressSliderProps = SliderNewsProps & SectionOneColumnProps;

/**
 * COMPONENT
 */
export const SectionPressSlider: FC<SectionPressSliderProps> & BlockConfigs = ({
	posts = [],
	...props
}) => {
	return isEmpty(posts) ? null : (
		<SectionAccordion {...props}>
			<SliderNews posts={posts} />
		</SectionAccordion>
	);
};

SectionPressSlider.slug = block.slug;
SectionPressSlider.title = block.title;
